import {
	SET_VALUE_ARRAY_SIZE_LIMIT,
	baseScopesRequiredPerField,
	isNotAutomaticId,
} from '@atlassian/jira-issue-adjustments/src/common.tsx';
import { isNotEmptyString } from '../utils/is-not-empty-string/index.tsx';

export type PublicValue = {
	accountId: string;
};

export type PeoplePublicGetValue = PublicValue[];

export type PeoplePublicSetValue = string[];

export const validatePeopleSetValue = (value: unknown): value is PeoplePublicSetValue =>
	Array.isArray(value) &&
	value.length <= SET_VALUE_ARRAY_SIZE_LIMIT &&
	value.every((option) => isNotEmptyString(option) && isNotAutomaticId(option));

export const peopleScopes = baseScopesRequiredPerField;
